/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type LimitPaymentOptionsToEnum = 's' | 'w' | '11184809';

export const LimitPaymentOptionsToEnum = {
  S: 's' as LimitPaymentOptionsToEnum,
  W: 'w' as LimitPaymentOptionsToEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as LimitPaymentOptionsToEnum
};
